export enum WebsiteStylesSettingsTypeEnum {
  Typography = 'typography',
  ThemesAndColors = 'themes_and_colors',
  ButtonsAndLinks = 'buttons_and_links',
  FormFields = 'form_fields',
  Layout = 'layout',
}
